module.exports = __webpack_public_path__ + "media/images/pc/reports/main-visual-adb35f2c2925103e33677bff2e935175.jpg";